/** Eigenständiger Revisionsstand, analog zur Excel-Spalte REVISION: "00" (Erstangebot) bis "99". */
export const REVISION_STANDS = Array.from({ length: 100 }, (_, i) => String(i).padStart(2, '0')) as readonly string[];

export type RevisionStand = typeof REVISION_STANDS[number];

export const isRevisionStand = (value: unknown): value is RevisionStand =>
  typeof value === 'string' && REVISION_STANDS.includes(value);

export const padRevisionStand = (value: number): RevisionStand | null => {
  if (!Number.isInteger(value) || value < 0 || value > 99) {
    return null;
  }
  return String(value).padStart(2, '0');
};

export const revisionStandIndex = (stand?: string | null): number =>
  isRevisionStand(stand) ? parseInt(stand, 10) : -1;
